module.exports = __WEBPACK_EXTERNAL_MODULE_188__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 188
// module chunks = 3 4